module.exports = __webpack_public_path__ + "static/carpool-gallery-12-a5a487b4fe544255ea30bad6e70225b4.jpg";